export let ImpersonateStep;

(function (ImpersonateStep) {
  ImpersonateStep["impersonating"] = "impersonating";
  ImpersonateStep["success"] = "success";
})(ImpersonateStep || (ImpersonateStep = {}));